import React from 'react';
import PropTypes from 'prop-types';
import { Waypoint } from 'react-waypoint';
import isEmpty from 'lodash/isEmpty';

import { gettext } from '@eventbrite/i18n';

import { GA_SETTINGS_PROP_TYPE } from '@eventbrite/site-analytics';
import {
    withFollow,
    addFollow,
    FollowCard,
} from '@eventbrite/follow-organizer-ebui';

import { useOrganizerIds } from './hooks';
import './FeaturedOrganizerContainer.scss';

const EnhancedFollowCard = withFollow(FollowCard);

const WAYPOINT_TOP_OFFSET = '1px';

const OrganizerList = addFollow(({ organizers, children }) => {
    const organizerCards = organizers.map((organizerId) => (
        <li key={organizerId} className="list-item">
            <EnhancedFollowCard
                style="grid"
                size="standard"
                organizerId={organizerId}
                shouldHideDefaultDataPoint={true}
            />
        </li>
    ));

    return (
        <ul className="featured-organizer-section__organizer-list">
            {organizerCards}
            {children}
        </ul>
    );
});

export const FeaturedOrganizerSection = (props) => {
    const [hasScrolledIntoView, setScrolledIntoView] = React.useState(false);
    const organizerIds = useOrganizerIds(props.isQuality, props.collectionId);

    if (!organizerIds || isEmpty(organizerIds)) {
        return null;
    }

    let organizerList = null;

    if (hasScrolledIntoView) {
        organizerList = (
            <OrganizerList
                organizers={organizerIds}
                gaSettings={props.gaSettings}
                gaCategory={props.gaCategory}
                userId={props.userId}
                isAuthenticated={props.isAuthenticated}
                isGDPRCountry={props.isGDPRCountry}
            />
        );
    }

    return (
        <Waypoint
            onEnter={() => setScrolledIntoView(true)}
            topOffset={WAYPOINT_TOP_OFFSET}
        >
            <section className="featured-organizer-section__organizer-container">
                <div className="featured-organizer-section__title-container">
                    <h1 className="featured-organizer-section__title eds-text-hs">
                        {gettext('Featured organizers')}
                    </h1>
                    <h2 className="featured-organizer-section__subtitle eds-text-bm">
                        {gettext(
                            'Follow the organizers from this collection and get notified when they create events.',
                        )}
                    </h2>
                </div>
                <div className="featured-organizer-section__organizer-list-container">
                    {organizerList}
                </div>
            </section>
        </Waypoint>
    );
};

FeaturedOrganizerSection.propTypes = {
    /*
     * Category for Google Analytics, used by follow organizer
     */
    gaCategory: PropTypes.string,
    /*
     * Settings for Google Analytics
     */
    gaSettings: GA_SETTINGS_PROP_TYPE,
    /*
     * Current user's ID
     */
    userId: PropTypes.string,
    /*
     * Current logged in status
     */
    isAuthenticated: PropTypes.bool,
    /*
     * Whether the country is within GDPR regulations.
     */
    isGDPRCountry: PropTypes.bool,
};

export default FeaturedOrganizerSection;
